<button
  [type]="type()"
  class="rounded flex justify-center items-center w-full border"
  [class.bg-blue]="variant() === 'primary'"
  [class.border-red-600]="variant() === 'alert'"
  [class.border-blue]="variant() === 'secondary'"
  [class.text-red-600]="variant() === 'alert'"
  [class.text-blue]="variant() === 'secondary'"
  [class.text-dark-grey]="variant() === 'ghost'"
  [class.text-white]="variant() === 'primary'"
  [class.cursor-not-allowed]="disabled()"
  [class.opacity-50]="disabled()"
  [class.px-5]="small()"
  [class.px-8]="!small()"
  [class.py-2]="small()"
  [class.py-4]="!small()"
  [class.underline]="variant() === 'ghost'"
  [class.underline-offset-2]="variant() === 'ghost'"
  [class.w-full]="fullWidth()"
  [class.border-0]="variant() === 'alert'"
  [disabled]="disabled()"
  (click)="clicked.emit()"
>
  @if (isLoading()) {
    <app-spinner
      [ngClass]="{ invisible: !isLoading() }"
      [color]="'rgba(255,255,255)'"
    />
  } @else {
    <span
      class="leading-4"
      [ngClass]="{ invisible: isLoading() }"
    >
      {{ text() }}
    </span>
  }
</button>
